import type {FormSchemaProperty, FormFieldSchema} from '../../../core/nutshell-fields/types';

import type {MergeTagOption} from './add-merge-field';

export function getFilteredFields(schemaFields: FormSchemaProperty[]): any[] {
    const filteredFields = schemaFields.filter(
        (field) =>
            field.entityType !== 'Leads' && field.isCustomField && field.type !== 'enum-multiple'
    );

    return filteredFields;
}

export function getSelectedField(
    formSchema: FormFieldSchema,
    selectedMergeTag: MergeTagOption
): any {
    const fields = Object.values(formSchema.properties);

    return fields.find((field) => field.mergeTagName === selectedMergeTag.value);
}
